module.exports = __webpack_public_path__ + "media/images/cover/blue-house-c63e98f6d480c5a7115c8ffc1dccca02.jpg";